/**
 * Lease start date lead time validation – shared message and detection.
 * Matches Angular: show Validation Message modal (center popup), never as notification.
 *
 * Angular source: invite-add.component.ts line 466-469
 *   this.appService.notify(`...`, 0)  →  dialogService.confirm({ title: 'Validation Message', message, buttons: { positiveTitle: 'Ok' } })
 */

/** HTML message matching Angular exactly (rendered via innerHTML / dangerouslySetInnerHTML). */
export const LEASE_LEAD_TIME_VALIDATION_HTML =
  `You have set the lease start date beyond your companies lead time, to have this changed contact your property or regional manager.<br>If you feel you have reached this message in error contact customer service <a href="tel:8775817368"> 877-581-7368</a>`;

/** Detect if an API/form error is the lead time message (so we show modal instead of notification). */
export function isLeadTimeValidationError(message: string): boolean {
  const plain = message.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim().toLowerCase();
  return (
    plain.includes("lease start date beyond") ||
    plain.includes("companies lead time") ||
    plain.includes("company lead time")
  );
}
